export class ResultPlotData {
    public x: number[];
    public y: number[];

    public constructor(init: Partial<ResultPlotData>) {
        Object.assign(this, init);
    }
}

export class PointResult {
    public concentration: number[];
    public massDischarge: number[];
    public excessFactor: number[];
    public wellConcentration: number[];
    public verticalModelOutput: ResultPlotData[];
    public horizontalPlumeConcentration: ResultPlotData[];
    public plumeConcentrationAtPoC: ResultPlotData[];
    public aquiferTopConcentration: ResultPlotData[];

    public constructor(init: Partial<PointResult>) {
        Object.assign(this, init);
    }
}

export class CalculationResult {
    public pointResults: PointResult[];

    public constructor(init: Partial<CalculationResult>) {
        Object.assign(this, init);
    }
}
